export default __webpack_public_path__ + "static/media/desk-clean4.62a4fc32.png";